import React from 'react'

export default function Name({children}) {
  return <li className='name'>{children}</li>
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/InfoBlockComponents/Name.js